const data = [
  {
    question: "Is it safe to add money to CoinStorey?",
    answer:
      "Adding money to your coinstorey account is both simple and safe. We have many different payment options enabled on coinstorey and work hard to ensure that your personal details are safe with us.What's more, after you verify your personal details, you can withdraw the money that you win on CoinStorey directly to your bank account.",
  },
  {
    question: "Can I actually win money on Coinstorey?",
    answer:
      "Absolutely! Lots of players have already won big prizes on Coinstorey and you can too. We host different kinds of cash contests, each with its own entry fee and prize money.Choose a contest that you want to play, defeat the competition, and celebrate big wins!",
  },

  {
    question: " How does coinstorey fantasy contests work?",
    answer:
      " On Coinstorey, you create your fantasy portfolio based on a real-life price action in the crypto market to score maximum profits and win exciting cash prizes worth Crores!",
  },

  {
    question: "How do I transfer the prize money into my bank account?",
    answer:
      "Go to 'coinstorey' > ' My wallet ' > 'Withdraw Cash'.:You can only withdraw an amount less than or equal to your withdrawable balance.",
  },
  {
    question: "How long will it take for a money transfer?",
    answer:
      " The duration it takes for the withdrawal request to be processed and get credited to your Bank A/c depends on the mode of transaction. We have different modes for processing withdrawals. Visit the Withdraw Cash page for more details.",
  },
  {
    question: "Why doesn't my prize money reflect in my account?",
    answer:
      " The prize money reflects within 4 hours of the match being concluded.",
  },
  {
    question: "What if there's a tie between contestants?",
    answer:
      "The prize money will be equally distributed between tied contestants. For example, if there's a tie between two players in a contest of prize money ₹10,000, the tied players will get ₹5,000 each.",
  },
  {
    question: "Can I play if I am under the age of 18?",
    answer:
      "No, you have to be 18 or above to play in the CoinStorey contest.b",
  },
  {
    question: "Why was my money refunded?",
    answer:
      "We refund your money within 24 hours when a contest is cancelled. This happens only if the contest does not gather the required number of contestants.",
  },
  {
    question: "  How will I know if I have won a prize money?",
    answer:
      " Depending on your profits and ranking of a contest, your winnings will be credited automatically to your coinstorey wallet.",
  },
  {
    question: "When do I get the result of a contest?",
    answer:
      " Based on the scorecard, our team will verify and update the rankings within a couple hours after the match. Please note that this process may take long to ensure accuracy.",
  },
  {
    question: "What if I do not withdraw my prize money?",
    answer: "  Your prize money remains safe with us.",
  },
  {
    question: "Can I join a contest once the contest starts?",
    answer: "No, players can join the contest till the contest starts.",
  },
  {
    question: "Can I leave the contest once I joined?",
    answer: "No, you cannot leave a contest after joining.",
  },
  {question: "What is the minimum amount I can withdraw?",answer: "The minimal withdrawal amount is ₹100."},
  {question: "  What is the maximum amount I can withdraw?",answer: "You can withdraw up to 75000 in 3 trenches per day."}
];
export default data;
